<template>
    <section :class="ui.root()">
        <h1 :class="ui.hiddenTitle()">
            {{ title ?? header }}
        </h1>

        <div :class="ui.logoWrap()">
            <NuxtImg :src="logoSrc" :class="ui.logo()" />
        </div>

        <div :class="ui.card()">
            <div :class="ui.sideGlow()"></div>
            <div :class="ui.innerHighlight()"></div>
            <div :class="ui.radialGlow()"></div>

            <div :class="ui.content()">
                <div :class="ui.headerWrap()">
                    <h2 :class="ui.header()">
                        {{ header }}
                    </h2>

                    <p :class="ui.subheader()">
                        {{ subheader }}
                    </p>
                </div>

                <slot />

                <div v-if="footerPrompt" :class="ui.footer()">
                    <div :class="ui.footerContent()">
                        <span :class="ui.footerPrompt()">{{ footerPrompt }}</span>
                        <UButton
                            :label="footerLabel"
                            :disabled="footerDisabled"
                            :variant="ButtonVariants.AuthFooter"
                            @click="navigateTo(footerTo)" />
                    </div>
                </div>
            </div>
        </div>

        <slot name="bottom" />
    </section>
</template>

<script setup lang="ts">
    import { ButtonVariants } from '@constants/button-variants';

    defineProps({
        logoSrc: {
            type: String,
            default: '/images/logo-lockup.png'
        },
        title: {
            type: String
        },
        header: {
            type: String,
            default: 'Welcome Back'
        },
        subheader: {
            type: String,
            default: 'Members Access Only'
        },
        footerPrompt: {
            type: String
        },
        footerLabel: {
            type: String,
            default: 'Sign In'
        },
        footerTo: {
            type: String,
            default: '/login'
        },
        footerDisabled: {
            type: Boolean
        }
    });

    const ui = useComponentUi('authPanel');
</script>
